import React from 'react';

import { SessionInformation } from '~/presentation/components/sessionInformation';
import { Action, InfoUser } from '.';
import { SessionData, UserData } from './interface';
import { Container } from './styles/StyledCard';

interface ownProps {
  user?: UserData;
  session?: SessionData;
}

const Card: React.FC<ownProps> = ({ user, session }) => {
  console.log('user', user);
  console.log('session', session);

  return (
    <Container>
      <SessionInformation session={session} />
      <InfoUser user={user} />
      {session?.status === 'ENDED' ? null : (
        <Action status={session?.status} cancelDate={session?.cancelDate} />
      )}
    </Container>
  );
};

export default Card;
